import { StyleSheet, Text, View } from 'react-native';

import { colorSemantic } from '@/theme';

export interface AppbarTitleProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly variant?: 'default' | 'dark';
  readonly testID?: string;
}

export const AppbarTitle = ({ title, subtitle, variant = 'default', testID }: AppbarTitleProps) => {
  const color =
    variant === 'dark' ? colorSemantic.colorTextNlPrimary : colorSemantic.colorTextNdPrimary;
  const id = testID ?? 'appbar-title';

  return (
    <View style={styles.container} testID={testID}>
      <Text numberOfLines={1} style={[styles.title, { color }]} testID={`${id}-title`}>
        {title}
      </Text>
      {subtitle ? (
        <Text numberOfLines={1} style={[styles.subtitle, { color }]} testID={`${id}-subtitle`}>
          {subtitle}
        </Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    flex: 1,
    justifyContent: 'center',
  },
  title: {
    fontSize: 22,
    lineHeight: 28,
    marginBottom: -4,
  },
  subtitle: {
    fontSize: 12,
    letterSpacing: 0.15,
    lineHeight: 24,
  },
});
